export type Lexicon = {
  term: string;
  description?: string;
  link?: string;
};

export const BORROW_FEE: Lexicon = {
  term: "Borrowing Fee",
  description:
    "The Borrowing Fee is a one-off fee charged as a percentage of the borrowed amount (in INCD) and is part of a Vault's debt. The fee varies between 0.5% and 5% depending on INCD system offset volumes.",
};

export const TVL: Lexicon = {
  term: "TVL",
  description:
    "The Total Value Locked (TVL) is the total value of INC Token locked as collateral in the system, given in INC and USD.",
};

export const STAKED_LQTY: Lexicon = {
  term: "Staked PRINT",
  description:
    "The total amount of PRINT that is staked for earning fee revenue.",
};

export const TCR: Lexicon = {
  term: "Total Collateral Ratio",
  description:
    "The ratio of the Dollar value of the entire system collateral at the current INC:USD price, to the entire system debt.",
};

export const RECOVERY_MODE: Lexicon = {
  term: "Recovery Mode",
  description:
    "Recovery Mode is activated when the Total Collateral Ratio (TCR) falls below 150%. When active, your Vault can be liquidated if its collateral ratio is below the TCR. The maximum collateral you can lose from liquidation is capped at 110% of your Vault's debt. Operations are also restricted that would negatively impact the TCR.",
};

export const STABILITY_POOL_LUSD: Lexicon = {
  term: "INCD in Stability Pool",
  description:
    "The total INCD currently held in the Stability Pool, expressed as an amount and a fraction of the INCD supply.",
};

export const KICKBACK_RATE: Lexicon = {
  term: "Kickback Rate",
  description:
    "A rate between 0 and 100% set by the Frontend Operator that determines the fraction of PRINT that will be paid out as a kickback to the Stability Providers using the frontend.",
};

export const ETH: Lexicon = {
  term: "INC",
};

export const LUSD: Lexicon = {
  term: "INCD",
};

export const LQTY: Lexicon = {
  term: "PRINT",
};

//
export const ALLOWANCE: Lexicon = {
  term: "INC Allowance",
  description: "INC Allowance",
};

//Shinto: Distribution
export const LIQUIDIDATION_NORMAL: Lexicon = {
  term: "Liquidation Price (Normal Mode)",
  description: "The USD value at which your Vault will drop below 110% Collateral Ratio and be at risk of liquidation. You should manage your position to de avoid liquidation by monitoring normal mode liquidation price",
};

export const LIQUIDIDATION_RECOVERY: Lexicon = {
  term: "Liquidation Price (Recovery Mode)",
  description: "The USD value at which your Vault will drop below 150% Collateral Ratio and be at risk of liquidation during Recovery Mode. You should be manage your position to avoid liquidation by monitoring the recovery mode liquidation price.",
};

export const SYSTEM_OFFSET: Lexicon = {
  term: "System Offset",
  description: "System Offset",
};

export const DISTRIBUTION: Lexicon = {
  term: "Claim Your PRINT Token",
  description: "Claim Your PRINT Token",
};

export const TROVES: Lexicon = {
  term: "Vaults",
  description: "The total number of active Vaults in the system.",
};

export const LUSD_SUPPLY: Lexicon = {
  term: "INCD supply",
  description: "The total INCD minted by the INC Printer Protocol.",
};

export const MPINC: Lexicon = {
  term: "Market Price",
  description: "The current INC Market Price",
};

export const MPINCD: Lexicon = {
  term: "Market Price",
  description: "The current INCD Market Price",
};

export const MPPRINT: Lexicon = {
  term: "Market Price",
  description: "The current PRINT Market Price",
};

export const OPPRINT: Lexicon = {
  term: "Oracle Price",
  description: "The current INC Oracle Price",
};
